(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PropertyPath"] = factory();
	else
		root["Peace"] = root["Peace"] || {}, root["Peace"]["PropertyPath"] = factory();
})(this, function() {
return 